import { ReactElement, useEffect } from 'react';

import { env } from 'config';

declare const window: Window &
  typeof globalThis & {
    Netomi?: {
      chat?: {
        init: (callback: () => void) => void;
      };
    };
  };

export const Netomi = (): ReactElement => {
  useEffect(() => {
    if (!env.NETOMI_BOT_REF_ID) {
      return;
    }

    const existingScript = document.getElementById(
      'netomi-chat-script',
    ) as HTMLScriptElement | null;

    if (existingScript) {
      window.Netomi?.chat?.init(() => {
        // add publish events here
      });
      return;
    }

    const netomiScript = document.createElement('script');
    netomiScript.id = 'netomi-chat-script';
    netomiScript.src = 'https://chatapps-us.netomi.com/app/script.js';
    netomiScript.type = 'text/javascript';
    netomiScript.async = true;
    netomiScript.setAttribute('botRefId', env.NETOMI_BOT_REF_ID);

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(netomiScript, firstScript);
    } else {
      document.body.appendChild(netomiScript);
    }

    netomiScript.onload = () => {
      window.Netomi?.chat?.init(() => {
        // add publish events here
      });
    };
  }, []);

  return <div />;
};

export default Netomi;
